'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionCreators = require('../../../../store/actions/action-creators');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var CONTINUOUS_PLAYBACK_THRESHOLD = 800;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var player = state.players && state.players[ownProps.playerId] || {
    playingIndex: 0
  };

  var logData = _extends({
    isAutoAdvance: false,
    isAutoPlay: true,
    isInlinePlay: true,
    isMuted: player.muted || false,
    skipViewBump: false
  }, ownProps.logData);

  var currentTimeMs = 0;
  var ended = false;
  var playingIndex = player.playingIndex;

  if (ownProps.playingIndex === playingIndex) {
    currentTimeMs = ownProps.currentTimeMs;
    ended = player.durationMs > 0 && player.durationMs - currentTimeMs < CONTINUOUS_PLAYBACK_THRESHOLD;
  }

  return {
    currentTimeMs: currentTimeMs,
    ended: ended,
    logData: logData,
    playingIndex: playingIndex,
    durationMs: player.durationMs || 0,
    isLastPlaylistItem: player.playables && player.playingIndex === player.playables.size - 1,
    adPlaying: player.adBegan && !player.adEnded,
    communityContentId: (player.playables && player.playables.get(playingIndex) || {}).communityContentId,
    paused: player.paused
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    communityContentVideoPlay: _actionCreators.communityContentVideoPlay,
    communityContentVideoPositionUpdated: _actionCreators.communityContentVideoPositionUpdated,
    communityContentVideoStopped: _actionCreators.communityContentVideoStopped,
    communityContentEnterView: _actionCreators.communityContentEnterView,
    communityContentLeaveView: _actionCreators.communityContentLeaveView
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);